import { RewardPool } from '@shared/api/types/rewardPools';

import { calculateMaxAvailableTickets } from '@store:web/components/entities/rewardPool';

const PRESET_VALUES = ['5', '10', '25'];

type Props = {
  balance: number;
  price: number;
  onChange: (value: string) => void;
  rewardPool: RewardPool;
  entryAmount: number;
};

export const PresetButtons = ({ balance, price, onChange, entryAmount, rewardPool }: Props) => {
  const onClickMaxHandler = () => {
    const intMax = calculateMaxAvailableTickets({ balance, price, entryAmount, rewardPool });
    onChange(String(intMax));
  };

  const onClickHandler = (value: string) => {
    return () => {
      onChange(value);
    };
  };

  return (
    <div className="flex w-full justify-between gap-2">
      {PRESET_VALUES.map((presetValue) => {
        return (
          <button
            type="button"
            className="msq-btn msq-btn-secondary msq-btn-sm w-full"
            key={presetValue}
            onClick={onClickHandler(presetValue)}
          >
            {presetValue}
          </button>
        );
      })}
      <button
        type="button"
        className="msq-btn msq-btn-secondary msq-btn-sm w-full"
        key="max-button"
        onClick={onClickMaxHandler}
      >
        Max
      </button>
    </div>
  );
};
